import { useQuery } from '@tanstack/react-query';

import { Email } from '@ndvr/customer-api';

import { CustomerApi } from 'API';

export const EmailQueryKeys = {
    EmailsQueryKey: (householdGUID: string) => ['Emails', householdGUID] as const,
    EmailQueryKey: (emailGUID: string) => ['Email', emailGUID] as const,
} as const;

export const useEmailsQuery = (householdGUID: string) =>
    useQuery<Email[]>({
        enabled: !!householdGUID,
        queryKey: EmailQueryKeys.EmailsQueryKey(householdGUID),
        queryFn: async () => {
            const [response] = await CustomerApi().listEmailsByHousehold(householdGUID);
            return response || [];
        },
        refetchOnMount: false,
        staleTime: Infinity,
    });

export const useEmailQuery = (emailGUID: string) => {
    return useQuery<Email | null>({
        enabled: !!emailGUID,
        queryKey: EmailQueryKeys.EmailQueryKey(emailGUID),
        queryFn: async () => {
            const [response] = await CustomerApi().getEmail(emailGUID);
            return response;
        },
    });
};
